import{styled as t}from"@mui/material/styles";const i=t("div")((({theme:t})=>({marginBottom:t.spacing(2),position:"relative",aspectRatio:"16/9",iframe:{position:"absolute",top:0,left:0,width:"100%",height:"100%"}})));export{i as VideoWrapper};
//# sourceMappingURL=styles.js.map
